import { auth0ApiClient } from './auth0ApiClient'
import { CuratedFeedTopic } from './curatedSourceService'
import type { ReactionType } from '@/types/feed'

export interface CuratedFeedItem {
  id: string
  sourceId: string
  sourceName: string
  topic: CuratedFeedTopic
  title: string
  link: string
  summary: string
  thumbnailUrl: string | null
  publishedAt: string
  commentCount: number
  reactionCounts: Record<string, number>
  viewerReaction?: ReactionType
}

export interface CuratedFeedPage {
  items: CuratedFeedItem[]
  hasMore: boolean
  nextCursor?: string
}

export interface CuratedFeedSource {
  id: string
  name: string
  topic: CuratedFeedTopic
}

interface PaginatedEnvelope<T> {
  success: boolean
  data: T[]
  pagination: {
    hasMore: boolean
    nextCursor?: string
  }
}

interface ListEnvelope<T> {
  success: boolean
  data: T[]
}

class CuratedFeedService {
  private readonly baseUrl = '/feed/curated'

  async getFeed(params: { cursor?: string; limit?: number; sourceId?: string } = {}): Promise<CuratedFeedPage> {
    const usp = new URLSearchParams()
    if (params.cursor) usp.append('cursor', params.cursor)
    if (params.limit) usp.append('limit', String(params.limit))
    if (params.sourceId) usp.append('sourceId', params.sourceId)
    const query = usp.toString()

    const env = await auth0ApiClient.getEnvelope<PaginatedEnvelope<CuratedFeedItem>>(
      `${this.baseUrl}${query ? `?${query}` : ''}`
    )
    return {
      items: env.data,
      hasMore: env.pagination.hasMore,
      ...(env.pagination.nextCursor && { nextCursor: env.pagination.nextCursor })
    }
  }

  async listSources(): Promise<CuratedFeedSource[]> {
    const env = await auth0ApiClient.getEnvelope<ListEnvelope<CuratedFeedSource>>(`${this.baseUrl}/sources`)
    return env.data
  }
}

export const curatedFeedService = new CuratedFeedService()
